export default "__VITE_ASSET__DnEr1i2y__"